if ($('#app-invoices').length) {
    //DOW Cell Editor
    function DOWCellEditorInvoice() {
    }

    DOWCellEditorInvoice.prototype.init = function (params) {
        console.log("params", params);
        console.log("parseValue", params.parseValue());
        console.log("formatValue", params.formatValue());
        this.api = params.api;
        this.eDiv = document.createElement('div');
        div = $(this.eDiv);
        div.addClass('grid-popup-container').addClass('grid_dow_container');
        div.html('<div class="row"><div class="col-lg-12 text-center dow_output"><div class="pull-left"><i class="fa fa-question-circle fa-fw" data-toggle="modal" data-target="#DOWHelpModal"></i></div><input readonly placeholder="-------"/><div class="pull-right"><i class="fa fa-times fa-fw grid-popup-close"></i></div></div><div class="col-lg-12 text-center"><div class="grid-input dow_shorthand dow_input"><div class="pull-left"><i class="fa fa-calendar-o fa-fw input-toggle"></i></div><input/></div></div><div class="col-lg-12 text-center"><div class="grid-input dow_select dow_input" style="display: none;"><div class="pull-left"><i class="fa fa-font fa-fw input-toggle"></i></div><div class="btn-group" role="group" aria-label="..."><button type="button" class="btn btn-default btn-sm">M</button><button type="button" class="btn btn-default btn-sm">T</button><button type="button" class="btn btn-default btn-sm">W</button><button type="button" class="btn btn-default btn-sm">R</button><button type="button" class="btn btn-default btn-sm">F</button><button type="button" class="btn btn-default btn-sm">S</button><button type="button" class="btn btn-default btn-sm">U</button></div></div></div></div>');
        this.tabbed = false;

        this.eInput = div.find('input')[0];

        input = $(div.find('.dow_shorthand input')[0]);
        buttons = div.find('.dow_select button');

        input.mask('m,t,w,r,f,s,u', {
            'translation': {
                m: {pattern: /m|M/, optional: true},
                t: {pattern: /t|T/, optional: true},
                w: {pattern: /w|W/, optional: true},
                r: {pattern: /r|R/, optional: true},
                f: {pattern: /f|F/, optional: true},
                s: {pattern: /s|S/, optional: true},
                u: {pattern: /u|U/, optional: true},
                ',': {pattern: /,/, optional: true}
            }
        });

        printable_keys = ['m', 'M', 't', 'T', 'w', 'W', 'r', 'R', 'f', 'F', 's', 'S', 'u', 'U'];
        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            // If a valid key, set that value.
            if (printable_keys.indexOf(params.charPress) >= 0) {
                div.find('.dow_shorthand input').val(params.charPress);
                div.find('.dow_output input').val(params.charPress);
                $.each(div.find('button'), function (index, value) {
                    if ($(value).html() == params.charPress) {
                        $(value).removeClass('btn-default').addClass('btn-primary');
                    } else {
                        $(value).addClass('btn-default').removeClass('btn-primary');
                    }
                });
                // Otherwise set the params value.
            } else {
                if (typeof params.value !== 'undefined' && params.value !== '') {
                    shorthand_value = '';
                    for (i = 0; i < params.value.length; i++) {
                        if (params.value[i] !== '-') {
                            shorthand_value += params.value[i] + ',';
                        }
                    }
                    shorthand_value = shorthand_value.substr(0, shorthand_value.length - 1);

                    div.find('.dow_shorthand input').val(shorthand_value);

                    $.each(div.find('button'), function (index, value) {
                        if (params.value[index] !== '-') {
                            $(value).removeClass('btn-default').addClass('btn-primary');
                        } else {
                            $(value).removeClass('btn-primary').addClass('btn-default');
                        }
                    });

                    div.find('.dow_output input').val(params.value);
                }
            }
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress == 8) || (params.keyPress == 46)) {
                div.find('.dow_shorthand input').val('');
                div.find('.dow_output input').val('-------');
                $.each(div.find('button'), function (index, value) {
                    $(value).removeClass('btn-primary').addClass('btn-default');
                });
                // Otherwise set the params value.
            } else {
                if (typeof params.value !== 'undefined' && params.value !== '') {
                    shorthand_value = '';
                    for (i = 0; i < params.value.length; i++) {
                        if (params.value[i] !== '-') {
                            shorthand_value += params.value[i] + ',';
                        }
                    }
                    shorthand_value = shorthand_value.substr(0, shorthand_value.length - 1);

                    div.find('.dow_shorthand input').val(shorthand_value);

                    $.each(div.find('button'), function (index, value) {
                        if (params.value[index] !== '-') {
                            $(value).removeClass('btn-default').addClass('btn-primary');
                        } else {
                            $(value).removeClass('btn-primary').addClass('btn-default');
                        }
                    });

                    div.find('.dow_output input').val(params.value);
                }
                if (params.keyPress == null) {
                    this.tabbed = true;
                }
            }
        }

        // DOW Shorthand
        input.bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            if (key == 37 || key == 39) {
                e.stopPropagation();
                return true;
            }

            if ((key == 188) && ($(this).val() == '')) {
                e.preventDefault();
                return true;
            }
        });

        input.bind('keyup', function () {
            var container = $(this).closest('.grid-popup-container');
            output = $(container.find('.dow_output input')[0]);
            if ($(this).val().length !== 0) {
                result = grid_parse_dow_shorthand(this);

                if (result !== false) {
                    output.val(result);
                }

                $.each(container.find('button'), function (index, value) {
                    if (result[index] !== '-') {
                        $(value).removeClass('btn-default').addClass('btn-primary');
                    } else {
                        $(value).removeClass('btn-primary').addClass('btn-default');
                    }
                });
            } else {
                output.val('-------');
                $.each(container.find('button'), function (index, value) {
                    $(value).removeClass('btn-primary').addClass('btn-default');
                });
            }
        });

        // DOW buttons
        buttons.bind('click', function () {
            if ($(this).hasClass('btn-primary')) {
                $(this).removeClass('btn-primary').addClass('btn-default');
            } else {
                $(this).removeClass('btn-default').addClass('btn-primary');
            }

            result = grid_parse_dow_buttons(this);
            container = $(this).closest('.grid-popup-container');

            output = $(container.find('.dow_output input')[0]);

            output.val(result);

            shorthand_value = '';
            for (i = 0; i < result.length; i++) {
                if (result[i] !== '-') {
                    shorthand_value += result[i] + ',';
                }
            }
            shorthand_value = shorthand_value.substr(0, shorthand_value.length - 1);

            container.find('.dow_shorthand input').val(shorthand_value);
        });

        div.find('.input-toggle').bind('click', function () {
            container = $(this).closest('.dow_input');
            container.hide();
            if (container.hasClass('dow_shorthand')) {
                container.closest('.grid-popup-container').find('.dow_select').show();
            } else {
                container.closest('.grid-popup-container').find('.dow_shorthand').show();
            }
        });


        // Stop editing on close click
        var grid_api = this.api;
        div.find('.grid-popup-close').bind('click', function () {
            grid_api.stopEditing();
        });
        // if(params.node.data.order_number !== "" && avail_edit_allowed.indexOf(params.node.data.int_id) === -1){
        div.find('.dow_shorthand input').val(params.value);
        div.find('.dow_output input').val(params.value);
        // }
    };

    DOWCellEditorInvoice.prototype.getGui = function () {
        $(this.eDiv).find('.dow_shorthand input').bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37) || (key === 39))) {
                e.stopPropagation();
                return true;
            }
        });
        return this.eDiv;
    };

    DOWCellEditorInvoice.prototype.afterGuiAttached = function () {
        $(this.eDiv).find('.dow_shorthand input').focus();
        if (this.tabbed) {
            $(this.eDiv).find('.dow_shorthand input').select();
        }
    };

    DOWCellEditorInvoice.prototype.getValue = function () {
        return this.eInput.value;
    };

    DOWCellEditorInvoice.prototype.destroy = function () {
        div = $(this.eDiv);
        input = $(div.find('.dow_shorthand input')[0]);
        buttons = div.find('.dow_select button');
        div.find('.grid-popup-close').unbind('click');
        div.find('.input-toggle').unbind('click');
        $(this.eDiv).find('.dow_shorthand input').unbind('keydown');
    };

    DOWCellEditorInvoice.prototype.isPopup = function () {
        return true;
    };

    function grid_parse_dow_buttons(button) {
        container = $(button).closest('.dow_select');

        string = '';

        $.each(container.find('button'), function () {
            if ($(this).hasClass('btn-primary')) {
                string += $(this).html();
            } else {
                string += '-';
            }
        });

        return string;
    }

    function grid_parse_dow_shorthand(input) {
        dows = {
            'M': 0,
            'T': 1,
            'W': 2,
            'R': 3,
            'F': 4,
            'S': 5,
            'U': 6
        };

        dows_keys = {
            0: 'M',
            1: 'T',
            2: 'W',
            3: 'R',
            4: 'F',
            5: 'S',
            6: 'U'
        };

        value = $(input).val();

        value = value.toUpperCase();

        var result = {
            'M': false,
            'T': false,
            'W': false,
            'R': false,
            'F': false,
            'S': false,
            'U': false
        };

        var last_input;
        for (i = 0; i < value.length; i++) {
            if (i == 0) {
                result[value[i]] = true;
                last_input = value[i];
            } else {
                if (value[i] == ',') {
                    i++;
                    result[value[i]] = true;
                } else {
                    loop_start = dows[value[i - 1]];
                    loop_end = dows[value[i]];

                    for (j = loop_start + 1; j < loop_end + 1; j++) {
                        result[dows_keys[j]] = true;
                    }

                    last_input = value[i];
                }
            }
        }

        string = '';
        if (result['M'] == true) {
            string += 'M';
        } else {
            string += '-';
        }
        if (result['T'] == true) {
            string += 'T';
        } else {
            string += '-';
        }
        if (result['W'] == true) {
            string += 'W';
        } else {
            string += '-';
        }
        if (result['R'] == true) {
            string += 'R';
        } else {
            string += '-';
        }
        if (result['F'] == true) {
            string += 'F';
        } else {
            string += '-';
        }
        if (result['S'] == true) {
            string += 'S';
        } else {
            string += '-';
        }
        if (result['U'] == true) {
            string += 'U';
        } else {
            string += '-';
        }

        return string;
    }


    //Time Period Cell Editor
    function TimePeriodCellEditorInvoice() {
    }

    TimePeriodCellEditorInvoice.prototype.init = function (params) {
        this.params = params;
        this.gridEl = params.eGridCell;
        this.api = params.api;
        this.eDiv = document.createElement('div');
        div = $(this.eDiv);
        div.addClass('grid-popup-container').addClass('grid_time_period_container');
        div.html('<div class="row"><div class="col-lg-12 text-center time_period_output"><div class="pull-left"><i class="fa fa-question-circle fa-fw" data-toggle="modal" data-target="#timePeriodHelpModal"></i></div><input readonly/><div class="pull-right"><i class="fa fa-times fa-fw grid-popup-close"></i></div></div><div class="col-lg-12 text-center"><div class="grid-input time_period_input time_period_shorthand"><div class="pull-left"><i class="fa fa-clock-o fa-fw input-toggle"></i></div><input/><i class="fa fa-ellipsis-h fa-fw grid-input-icon"></i></div></div><div class="col-lg-12 text-center time_period_input time_period_range" style="display:none;"><div class="pull-left"><i class="fa fa-font fa-fw input-toggle"></i></div><select class="range_start"></select> to <select class="range_end"></select></div></div>');
        this.tabbed = false;

        this.eInput = div.find('input')[0];

        input = $(div.find('.time_period_shorthand input')[0]);

        input.mask('ABBBC-ABBBC', {
            'translation': {
                A: {pattern: /\d/},
                B: {pattern: /\d/, optional: true},
                C: {pattern: /a|A|p|P/}
            }
        });

        // if(params.node.data.order_number !== "" && not_msg_validation_stations.indexOf(params.node.data.vendor) === -1/*avail_edit_allowed.indexOf(params.node.data.int_id) === -1*/){
        //     console.log(not_msg_validation_stations, params.node.data.vendor, "ENTERED TO THE NOT MSG VALIDATION")
        //     div.find('.time_period_output input').val(params.value);
        //     input.val(params.value)
        //     return;
        // }

        start_select = div.find('.time_period_range .range_start');
        end_select = div.find('.time_period_range .range_end');

        loop_start = moment().hour(0).minute(0).second(0);
        loop_end = moment().hour(23).minute(45).second(0);

        start_select.append('<option value=""></option>');
        end_select.append('<option value=""></option>');
        while (loop_start <= loop_end) {
            value = moment(loop_start).format('h:mm A');
            start_select.append('<option value="' + value + '">' + value + '</option>');
            end_select.append('<option value="' + value + '">' + value + '</option>');
            loop_start.add(15, 'minutes');
        }


        current_value = undefined;

        var shorthand_icon = div.find('.time_period_shorthand i.grid-input-icon');

        if (params.value !== '') {
            current_value = params.value.split('-');
            current_value[0] = moment(current_value[0], 'h:mmA');
            current_value[1] = moment(current_value[1], 'h:mmA');

        } else {
            current_value = [];
            current_value[0] = current_value[1] = '';
        }

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            number = parseInt(params.charPress);
            // If a number, set that value.
            if (!isNaN(number)) {
                input.val(number);
                start_select.val('');
                end_select.val('');
                shorthand_icon.removeClass('fa-check').addClass('fa-ellipsis-h');
                div.find('.time_period_output input').val(number);
                // Otherwise set the params value.
            } else {
                if (params.value !== '') {
                    input.val(current_value[0].format('hmmA').substring(0, current_value[0].format('hmmA').length - 1) + '-' +
                        current_value[1].format('hmmA').substring(0, current_value[1].format('hmmA').length - 1));
                    start_select.val(current_value[0].format('h:mm A'));
                    end_select.val(current_value[1].format('h:mm A'));
                    shorthand_icon.addClass('fa-check').removeClass('fa-ellipsis-h');
                    div.find('.time_period_output input').val(params.value);
                } else {
                    input.val('');
                    start_select.val('');
                    end_select.val('');
                    shorthand_icon.removeClass('fa-check').addClass('fa-ellipsis-h');
                    div.find('.time_period_output input').val('');
                }
            }
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress == 8) || (params.keyPress == 46)) {
                input.val('');
                start_select.val('');
                end_select.val('');
                shorthand_icon.removeClass('fa-check').addClass('fa-ellipsis-h');
                div.find('.time_period_output input').val('');
                // Otherwise set the params value.
            } else {
                if (params.value !== '') {
                    input.val(current_value[0].format('hmmA').substring(0, current_value[0].format('hmmA').length - 1) + '-' +
                        current_value[1].format('hmmA').substring(0, current_value[1].format('hmmA').length - 1));
                    start_select.val(current_value[0].format('h:mm A'));
                    end_select.val(current_value[1].format('h:mm A'));
                    shorthand_icon.addClass('fa-check').removeClass('fa-ellipsis-h');
                    div.find('.time_period_output input').val(params.value);
                } else {
                    input.val('');
                    start_select.val('');
                    end_select.val('');
                    shorthand_icon.removeClass('fa-check').addClass('fa-ellipsis-h');
                    div.find('.time_period_output input').val('');
                }
                if (params.keyPress == null) {
                    this.tabbed = true;
                }
            }
        }

        // Time Period shorthand
        input.bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            if (key == 37 || key == 39) {
                e.stopPropagation();
                return true;
            }
        });

        input.bind('keyup', function (e) {
            var key = e.which || e.keyCode;
            if ((!e.shiftKey) && ((key === 37) || (key === 39))) {
                return true;
            }
            shorthand_icon.removeClass('fa-check').addClass('fa-ellipsis-h');
            if (key == 8) {
                $(this).closest('.grid_time_period_container').find('.time_period_output input').val('');
                return true;
            }

            var time_period = $(this).val();

            var match = time_period.match(/(\d{1,4}a-\d{1,4}a)|(\d{1,4}a-\d{1,4}p)|(\d{1,4}p-\d{1,4}p)|(\d{1,4}p-\d{1,4}a)|(\d{1,4}A-\d{1,4}A)|(\d{1,4}A-\d{1,4}P)|(\d{1,4}P-\d{1,4}P)|(\d{1,4}P-\d{1,4}A)|(\d{1,4}a-\d{1,4}A)|(\d{1,4}a-\d{1,4}P)|(\d{1,4}p-\d{1,4}P)|(\d{1,4}p-\d{1,4}A)|(\d{1,4}A-\d{1,4}a)|(\d{1,4}A-\d{1,4}p)|(\d{1,4}P-\d{1,4}p)|(\d{1,4}P-\d{1,4}a)/g);

            if (match && (match.length == 1)) {
                var parts = time_period.split('-');

                var moment_start = grid_time_period_parse(parts[0]);
                var moment_end = grid_time_period_parse(parts[1]);

                if ((moment_start == false) || (moment_end == false)) {
                    return true;
                }

                container = $(this).closest('.grid-popup-container');

                str_start = moment_start.format('h:mmA').substring(0, moment_start.format('h:mmA').length - 1);
                str_end = moment_end.format('h:mmA').substring(0, moment_end.format('h:mmA').length - 1);

                container.find('.time_period_output input').val(str_start + '-' + str_end);

                container.find('.time_period_range .range_start').val(moment_start.format('h:mm A'));
                container.find('.time_period_range .range_end').val(moment_end.format('h:mm A'));

                shorthand_icon.addClass('fa-check').removeClass('fa-ellipsis-h');
            } else {
                $(this).closest('.grid_time_period_container').find('.time_period_output input').val('');
                return true;
            }


        });

        // Time period selects
        start_select.bind('change', function (e) {
            result = grid_time_period_range_change(this);

            if (result !== false) {
                grid_time_period_range_set(this, result);
            } else {
                $(this).closest('.grid_time_period_container').find('.time_period_output input').val('');
            }

            e.preventDefault();
        });

        end_select.bind('change', function (e) {
            result = grid_time_period_range_change(this);

            if (result !== false) {
                grid_time_period_range_set(this, result);
            } else {
                $(this).closest('.grid_time_period_container').find('.time_period_output input').val('');
            }

            e.preventDefault();
        });

        div.find('.input-toggle').bind('click', function () {
            container = $(this).closest('.time_period_input');
            container.hide();
            if (container.hasClass('time_period_shorthand')) {
                container.closest('.grid-popup-container').find('.time_period_range').show();
            } else {
                container.closest('.grid-popup-container').find('.time_period_shorthand').show();
            }
        });

        var grid_api = this.api;
        div.find('.grid-popup-close').bind('click', function () {
            grid_api.stopEditing();
        });
    };

    TimePeriodCellEditorInvoice.prototype.getGui = function () {
        return this.eDiv;
    };

    TimePeriodCellEditorInvoice.prototype.afterGuiAttached = function () {
        $(this.eDiv).find('.time_period_shorthand input').focus();
        if (this.tabbed) {
            $(this.eDiv).find('.time_period_shorthand input').select();
        }
    };

    TimePeriodCellEditorInvoice.prototype.getValue = function () {
        return this.eInput.value;
    };

    TimePeriodCellEditorInvoice.prototype.destroy = function () {
        div = $(this.eDiv);
        input = $(div.find('.time_period_shorthand input')[0]);
        start_select = div.find('.time_period_range .range_start');
        end_select = div.find('.time_period_range .range_end');
        input.unbind('keydown').unbind('keyup');
        start_select.unbind('change');
        end_select.unbind('change');
        div.find('.input-toggle').unbind('click');
        div.find('.grid-popup-close').unbind('click');
    };

    TimePeriodCellEditorInvoice.prototype.isPopup = function () {
        return true;
    };


    function grid_time_period_range_change(select) {
        container = $(select).closest('.time_period_range');

        var start = container.find('.range_start').val();
        var end = container.find('.range_end').val();

        if ((start !== '') && (end !== '')) {
            start = moment(start, 'h:mm A');
            end = moment(end, 'h:mm A');

            return [start, end];
        }

        return false;
    }

    function grid_time_period_range_set(select, result) {
        container = $(select).closest('.grid-popup-container');
        str_start = result[0].format('h:mmA').substring(0, result[0].format('h:mmA').length - 1);
        str_end = result[1].format('h:mmA').substring(0, result[1].format('h:mmA').length - 1);

        container.find('.time_period_output input').val(str_start + '-' + str_end);

        container.find('.time_period_shorthand input').val(
            result[0].format('hmmA').substring(0, result[0].format('hmmA').length - 1) + '-' +
            result[1].format('hmmA').substring(0, result[0].format('hmmA').length - 1));

        container.find('.time_period_shorthand i.grid-input-icon').addClass('fa-check').removeClass('fa-ellipsis-h');
    }

    function grid_time_period_parse(part) {
        var p, time, time_int;
        var moment_obj = moment().hour(0).minute(0).second(0);

        if ((part.indexOf('a') >= 0) || (part.indexOf('A') >= 0)) {
            p = 'a';
        }

        if ((part.indexOf('p') >= 0) || (part.indexOf('P') >= 0)) {
            p = 'p';
        }

        time = part.toLowerCase().replace(p, '');
        time_int = parseInt(time);

        // First check the length of the string, then parse if given proper values.
        if (time.length == 1) {
            if (p == 'p') {
                moment_obj.hour(time_int + 12);
            } else {
                moment_obj.hour(time_int);
            }
        } else if (time.length == 2) {
            if ((time_int > 9) && (time_int < 13)) {
                if (p == 'p') {
                    if (time_int !== 12) {
                        moment_obj.hour(time_int + 12);
                    } else {
                        moment_obj.hour(12);
                    }
                } else {
                    if (time_int !== 12) {
                        moment_obj.hour(time_int);
                    } else {
                        moment_obj.hour(0);
                    }
                }
            } else {
                if (p == 'p') {
                    moment_obj.hour(parseInt(time[0]) + 12).minute(parseInt(time[1] + '0'));
                } else {
                    moment_obj.hour(parseInt(time[0])).minute(parseInt(time[1] + '0'));
                }
            }
        } else if (time.length == 3) {
            if (p == 'p') {
                moment_obj.hour(parseInt(time[0]) + 12).minute(parseInt(time[1] + time[2]));
            } else {
                moment_obj.hour(parseInt(time[0])).minute(parseInt(time[1] + time[2]));
            }
        } else if (time.length == 4) {
            temp = parseInt(time[0]);

            if (temp !== 1) {
                return false;
            }

            if (p == 'p') {
                if (parseInt(time[0] + time[1]) !== 12) {
                    moment_obj.hour(parseInt(time[0] + time[1]) + 12).minute(parseInt(time[2] + time[3]));
                } else {
                    moment_obj.hour(12).minute(parseInt(time[2] + time[3]));
                }
            } else {
                if (parseInt(time[0] + time[1]) !== 12) {
                    moment_obj.hour(parseInt(time[0] + time[1])).minute(parseInt(time[2] + time[3]));
                } else {
                    moment_obj.hour(0).minute(parseInt(time[2] + time[3]));
                }

            }
        }

        return moment_obj;
    }


    // Length Format Render

    function LengthFormatRendererInvoice() {
    }

    LengthFormatRendererInvoice.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        $(this.eGui).css('text-align', 'center');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                this.eGui.innerHTML = ':' + params.value;
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '';
        }

    };

    LengthFormatRendererInvoice.prototype.getGui = function () {
        return this.eGui;
    };

    //Float Format Render
    function FloatFormatRendererInvoice() {
    }

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }


    FloatFormatRendererInvoice.prototype.init = function (params) {

        var val=0;
        this.eGui = document.createElement('div');
        $(this.eGui).attr("id", makeid());

        $(this.eGui).css('text-align', 'center');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                if (params.colDef.field === 'net_reach')
                    val = parseFloat(params.value).toFixed(0);
                else if(params.colDef.field === 'reach' || params.colDef.field === 'frequency' || params.colDef.field.indexOf('freq_') !== -1 || params.colDef.field.indexOf('rch_') !== -1){
                    val = Number(Math.round((parseFloat(params.value).toFixed(3)) + 'e2') + 'e-2').toFixed(2);
                }else
                    val = Number(Math.round((parseFloat(params.value).toFixed(2)) + 'e1') + 'e-1').toFixed(1)//parseFloat(params.value).toFixed(1);
                if (isNaN(val)) {
                    if (params.colDef.field === 'net_reach')
                        this.eGui.innerHTML = 0;
                    else
                        this.eGui.innerHTML = 0.0;
                } else
                    this.eGui.innerHTML = val;
            } else
                this.eGui.innerHTML = '';
        } else
            this.eGui.innerHTML = 0.0;

        if(params.colDef.field === 'rating' || params.colDef.field.indexOf('impressions') !== -1 || params.colDef.field === 'cume_rating' || params.colDef.field === 'cume' || params.colDef.field === 'share' || params.colDef.field === 'hut_put' || params.colDef.field.indexOf('rating_') !== -1 || params.colDef.field.indexOf('cume_rating_') !== -1 || params.colDef.field.indexOf('cume_') !== -1 || params.colDef.field.indexOf('share_') !== -1|| params.colDef.field.indexOf('hut_put_') !== -1) {

            if(params.colDef.field.indexOf('impressions') !== -1){
                if (typeof params.data['comments'] !== 'undefined' && params.data['comments'] !== null) {
                    var arr = params.data['comments'].split("<>");
                    var upd_imp = (params.colDef.field.indexOf('impressions_tv') !== -1) ? params.data['impressions_tv'] : params.data['impressions_radio'];
                    if ((typeof params.data['manual'] !== 'undefined' && params.data['manual']) || (typeof arr[1] !== 'undefined')) {
                        this.eGui.style.color = "Teal";
                        this.eGui.style.fontStyle = "italic";
                    } else {
                        this.eGui.style.color = "black";
                        this.eGui.style.fontStyle = "normal";

                    }
                }
            }else {
                if (typeof params.data['comments'] !== 'undefined' && params.data['comments'] !== null) {
                    var arr = params.data['comments'].split("<>");
                    if ((typeof params.data['manual'] !== 'undefined' && params.data['manual']) || (typeof arr[1] !== 'undefined' )) {
                        this.eGui.style.color = "Teal";
                        this.eGui.style.fontStyle = "italic";
                    } else {
                        this.eGui.style.color = "black";
                        this.eGui.style.fontStyle = "normal";
                    }
                }else{
                    if(typeof params.data['manual'] !== 'undefined' && params.data['manual']){
                        this.eGui.style.color = "Teal";
                        this.eGui.style.fontStyle = "italic";
                    }else {
                        this.eGui.style.color = "black";
                        this.eGui.style.fontStyle = "normal";
                    }
                }
            }

        }
        if(params.colDef.field.indexOf('imp_') !== -1 || params.colDef.field.indexOf('rat_') !== -1 || params.colDef.field.indexOf('shr_') !== -1 || params.colDef.field.indexOf('hput') !== -1 || params.colDef.field.indexOf('cum_') !== -1 || params.colDef.field.indexOf('crat_') !== -1){
            var demo_id = params.colDef.field.split('_')[1];
            if (typeof params.data['manual_' + demo_id] !== 'undefined') {
                if(params.data['manual_' + demo_id]){
                    this.eGui.style.color = "Teal";
                    this.eGui.style.fontStyle = "italic";
                }else{
                    this.eGui.style.color = "black";
                    this.eGui.style.fontStyle = "normal";
                }
            }else{
                this.eGui.style.color = "black";
                this.eGui.style.fontStyle = "normal";
            }
        }
        // if (params.column.colDef.field === 'rating' && typeof params.value == 'number') {
        //     this.eGui.style.fontStyle = 'italic';
        // }


    };

    FloatFormatRendererInvoice.prototype.getGui = function () {
        return this.eGui;
    };

    //Float Cell Editor

    function FloatCellEditorInvoice() {
    }

    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };

    FloatCellEditorInvoice.prototype.init = function (params) {
        this.tabbed = false;
        this.eInput = document.createElement('input');
        var el;
        if (params.column.colDef.field === 'rating') {
            el = new AutoNumeric(this.eInput,
                {
                    decimalPlaces: 1,
                    minimumValue: 0,
                    maximumValue: 100,
                    selectOnFocus: false,
                    caretPositionOnFocus: null,
                    digitGroupSeparator: ',',
                    digitalGroupSpacing: '3',
                    decimalCharacter: '.',
                    allowDecimalPadding: true,
                    showOnlyNumbersOnFocus: true,
                    showWarnings: false,
                });
            /*if (params.column.colDef.field === 'rating' && typeof params.value === 'number') {
                this.eInput.style.fontStyle = 'italic';
            }*/
        } else if(params.column.colDef.field.indexOf("dial_position") !== -1 || params.column.colDef.field.indexOf("impression") !== -1 || params.column.colDef.field === 'reach' || params.column.colDef.field === 'frequency' || params.column.colDef.field === 'grp' || params.column.colDef.field.indexOf("gi") !== -1)
        {
            el = new AutoNumeric(this.eInput,
                {
                    decimalPlaces: 1,
                    minimumValue: 0,
                    selectOnFocus: false,
                    caretPositionOnFocus: null,
                    digitGroupSeparator: ',',
                    digitalGroupSpacing: '3',
                    decimalCharacter: '.',
                    allowDecimalPadding: true,
                    showOnlyNumbersOnFocus: true,
                    showWarnings: false,
                });
        } else {
            el = new AutoNumeric(this.eInput,
                {
                    decimalPlaces: 2,
                    minimumValue: 0,
                    selectOnFocus: false,
                    caretPositionOnFocus: null,
                    digitGroupSeparator: ',',
                    digitalGroupSpacing: '3',
                    decimalCharacter: '.',
                    allowDecimalPadding: true,
                    showOnlyNumbersOnFocus: true,
                    showWarnings: false,
                });
        }

        if (params.charPress === null) {
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
            this.tabbed = true;
        }
        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat((params.charPress === ".") ? 0 : params.charPress);
            if(!isNaN(vv))
                el.set((params.charPress === ".") ? "0." : params.charPress);
            console.log("round1");
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(parseFloat(0));
                console.log("round0");
                // Otherwise set the params value.
            } else {
                if (params.column.colDef.field === 'rating' || params.column.colDef.field.indexOf("impression") !== -1 || params.column.colDef.field === 'reach' || params.column.colDef.field === 'frequency' || params.column.colDef.field === 'grp' || params.column.colDef.field.indexOf("gi") !== -1) {
                    el.set(parseFloat(params.value).toFixed(1));
                    console.log("round11:" + parseFloat(params.value).toFixed(1));
                } else {
                    console.log("round22");
                    el.set(parseFloat(params.value).toFixed(2));
                }
                if (params.charPress === null) {
                    console.log("???????????????????????????????");
                    this.tabbed = true;
                }
            }
        }
        console.log("INPUT INIT");
    };

    FloatCellEditorInvoice.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };

    FloatCellEditorInvoice.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            value_flag = -1;
            if(typeof value_flag_demo_analisis !== "undefined")
                value_flag_demo_analisis = -1
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                console.log("KD1");
                e.stopPropagation();
                return true;
            } else {
                if(parseFloat(this.value) <= 0){
                    console.log("keycode2");
                    /*console.log(e);
                    this.value = "." + e.originalEvent.key;*/
                }else{
                    console.log("keycode3");
                }
            }
            // Ignore commas.
            if(key === 188){
                console.log("KD4");
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        console.log("FOCUS");
        this.eInput.focus();
        if (this.tabbed === true) {
            console.log("TABBED");
            $(this.eInput).select();
        }else{
            if($(this.eInput).val() == "0.0" || $(this.eInput).val() == "0.00")
                $(this.eInput).setCursorPosition(2);
            else
                $(this.eInput).setCursorPosition(1);
        }
    };

    FloatCellEditorInvoice.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };

    FloatCellEditorInvoice.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };
    function UppercaseFormatRendererInvoice() {
    }

    UppercaseFormatRendererInvoice.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                console.log(' params.value ',  params.value );
                if (typeof params.value !== 'undefined' && params.value !== null && params.value !== '' && params.value !== -1) {
                    this.eGui.innerHTML = params.value.toUpperCase();
                } else {
                    this.eGui.innerHTML = '';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '';
        }
    };

    UppercaseFormatRendererInvoice.prototype.getGui = function () {
        return this.eGui;
    };

    function CurrencyFormatRendererInvoice() {
    }

    CurrencyFormatRendererInvoice.prototype.init = function (params) {
        this.eGui = document.createElement('div');

        //if (params.node.rowPinned !== 'top') {
        //    $(this.eGui).css('text-align', 'right');
        //}

        $(this.eGui).css('text-align', 'right');

        if (params.node.rowPinned !== 'bottom') {
            if (typeof params.value !== 'undefined') {
                if(params.colDef.field === 'cpm'){
                    console.log('TRTRTR params.colDef.field ', params.colDef.field, params.value);
                    if (isNaN(parseFloat(params.value)))
                        this.eGui.innerHTML = '$0.00';
                    else
                        this.eGui.innerHTML =  parseFloat(params.value).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            //minimumFractionDigits: 2
                        });
                }
                else if (params.colDef.field === 'gross_cpa' || params.colDef.field === 'net_cpa'){
                    if (typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                        this.eGui.innerHTML = 'TR';
                    else{
                        if (isNaN(parseFloat(params.value)))
                            this.eGui.innerHTML = '$0.00';
                        else
                            this.eGui.innerHTML =  parseFloat(params.value).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                //minimumFractionDigits: 2
                            });
                    }
                }
                else {
                    if (isNaN(parseFloat(params.value)))
                        this.eGui.innerHTML = '$0.00';
                    else
                        this.eGui.innerHTML =  parseFloat(params.value).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            //minimumFractionDigits: 2
                        });
                }

            } else
                this.eGui.innerHTML = '$0.00';

        } else {
            this.eGui.innerHTML = '';
        }
    };

    CurrencyFormatRendererInvoice.prototype.getGui = function () {
        return this.eGui;
    };


    function CurrencyCellEditorInvoice() {
    }

    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };
    CurrencyCellEditorInvoice.prototype.init = function (params) {
        // Auto calculate Net/Gross Rate based off of eachother.
        var curr_med = $(params.api.gridPanel.eRoot).closest("div.worksheet-grid").data("media");
        console.log('editing ', params);
        if (params.column.colId === 'gross_cpa' || params.column.colId === 'net_cpa'){
            if (typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                params.value = 0;
        }

        if (params.column.colId === 'net_cpa') {
            if ((params.node.data.gross_cpa !== '') && (typeof params.node.data.gross_cpa !== 'undefined')) {
                params.value = parseFloat(params.node.data.gross_cpa) * ((1 - (params.column.colDef.cellEditorParams.commission[curr_med] / 100)));
            } else {
                params.value = 0;
            }

        } else if (params.column.colId === 'gross_cpa') {
            if ((params.node.data.net_cpa !== '') && (typeof params.node.data.net_cpa !== 'undefined')) {
                params.value = parseFloat(params.node.data.net_cpa) / ((1 - (params.column.colDef.cellEditorParams.commission[curr_med] / 100)));
            } else {
                params.value = 0;
            }
        } else {
            if (params.value === '') {
                params.value = 0;
            }
        }
        this.eInput = document.createElement('input');
        var el = new AutoNumeric(this.eInput,
            {
                minimumValue: 0,
                selectOnFocus: false,
                caretPositionOnFocus: null,
                digitGroupSeparator: ',',
                digitalGroupSpacing: '3',
                decimalCharacter: '.',
                allowDecimalPadding: true,
                showOnlyNumbersOnFocus: true,
                showWarnings: false,
            });
        this.tabbed = false;
        if (params.charPress === null) {
            this.tabbed = true;
        }

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat((params.charPress === ".") ? 0 : params.charPress);
            if(!isNaN(vv))
                el.set((params.charPress === ".") ? "0." : params.charPress);
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(parseFloat(0));
                // Otherwise set the params value.
            } else {
                el.set(parseFloat(params.value).toFixed(2));
                if (params.charPress === null) {
                    this.tabbed = true;
                }
            }
        }
    };

    CurrencyCellEditorInvoice.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };

    CurrencyCellEditorInvoice.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            value_flag = -1
            if(typeof value_flag_demo_analisis !== "undefined")
                value_flag_demo_analisis = -1
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                e.stopPropagation();
                return true;
            }
            // Ignore commas.
            if(key === 188){
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        this.eInput.focus();
        if (this.tabbed) {
            $(this.eInput).select();
        }else{
            if($(this.eInput).val() == "0.00")
                $(this.eInput).setCursorPosition(2);
            else
                $(this.eInput).setCursorPosition(1);
        }
    };

    CurrencyCellEditorInvoice.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };

    CurrencyCellEditorInvoice.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };

    CurrencyCellEditorInvoice.prototype.isPopup = function () {
        return false;
    };

    function TiredRateCellEditorInvoice() {
    }

    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };
    TiredRateCellEditorInvoice.prototype.init = function (params) {
        // Auto calculate Net/Gross Rate based off of eachother.
        var curr_med = $(params.api.gridPanel.eRoot).closest("div.worksheet-grid").data("media");
        if (typeof params.value === 'undefined' || params.value === null) {
            params.value = null;
        }

        this.eInput = document.createElement('input');
        var el = new AutoNumeric(this.eInput,
            {
                minimumValue: 0,
                selectOnFocus: false,
                caretPositionOnFocus: null,
                digitGroupSeparator: ',',
                digitalGroupSpacing: '3',
                decimalCharacter: '.',
                allowDecimalPadding: true,
                showOnlyNumbersOnFocus: true,
                showWarnings: false,
            });
        this.tabbed = false;
        if (params.charPress === null) {
            this.tabbed = true;
        }

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat((params.charPress === ".") ? 0 : params.charPress);
            if(!isNaN(vv))
                el.set((params.charPress === ".") ? "0." : params.charPress);
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(null);
                // Otherwise set the params value.
            } else {
                el.set(parseFloat(params.value).toFixed(2));
                if (params.charPress === null) {
                    this.tabbed = true;
                }
            }
        }
    };

    TiredRateCellEditorInvoice.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };

    TiredRateCellEditorInvoice.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            value_flag = -1
            if(typeof value_flag_demo_analisis !== "undefined")
                value_flag_demo_analisis = -1
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                e.stopPropagation();
                return true;
            }
            // Ignore commas.
            if(key === 188){
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        this.eInput.focus();
        if (this.tabbed) {
            $(this.eInput).select();
        }else{
            if($(this.eInput).val() == null)
                $(this.eInput).setCursorPosition(2);
            else
                $(this.eInput).setCursorPosition(1);
        }
    };

    TiredRateCellEditorInvoice.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };

    TiredRateCellEditorInvoice.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };

    TiredRateCellEditorInvoice.prototype.isPopup = function () {
        return false;
    };
    function TiredRateFormatRendererInvoice() {
    }

    TiredRateFormatRendererInvoice.prototype.init = function (params) {
        this.eGui = document.createElement('div');

        $(this.eGui).css('text-align', 'right');

        if (params.node.rowPinned !== 'bottom') {
            if (typeof params.value !== 'undefined' && params.value != null) {
                param_val = parseFloat(params.value).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    //minimumFractionDigits: 2
                });
                if (isNaN(parseFloat(params.value))) {
                    console.log("NAN: " + parseFloat(params.value));
                    this.eGui.innerHTML = null;
                } else {
                    this.eGui.innerHTML = param_val;
                }
            } else {
                this.eGui.innerHTML = null;
            }
        } else {
            this.eGui.innerHTML = '';
        }
    };

    TiredRateFormatRendererInvoice.prototype.getGui = function () {
        return this.eGui;
    };

}



